module.exports = __webpack_public_path__ + "static/favicon-2d5b69d83b106bfd297d218075434ae8.png";